import {
  ElementRef,
  Inject,
  Injectable,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { RegionList } from './models';

@Injectable()
export class FlyoutLangSelectorExtendedComponent {
  isSearchFocused!: boolean;
  sortOptions: { name: string; descending: boolean } = {
    name: 'countryName',
    descending: false
  };

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) public platformId: Object,
    readonly elementRef: ElementRef,
    readonly renderer: Renderer2
  ) {}

  sortPositive() {
    return this.sortOptions.descending ? 1 : -1;
  }

  sortProperties(aValue: string, bValue: string) {
    if (aValue < bValue) {
      return this.sortPositive();
    } else if (aValue > bValue) {
      return this.sortOptions.descending ? -1 : 1;
    } else {
      return 0;
    }
  }

  scrollToTop() {
    const languageListElement = document.getElementById(
      'mach-core-langselector-languages-list'
    );
    if (languageListElement) {
      languageListElement.scrollTop = 0;
    }
  }

  scrollToView(regionView: HTMLAnchorElement) {
    setTimeout(() => {
      regionView.scrollIntoView();
    }, 100);
  }

  setHTMLOverflow() {
    document.getElementsByTagName('html')[0].style.overflow = '';
  }

  onSearchFieldFocus() {
    this.isSearchFocused = true;
  }

  onSearchFieldFocusout() {
    this.isSearchFocused = false;
  }

  focusToInput() {
    const idInputElement = document.getElementById(
      'mach-core-langselector-search-input'
    );

    idInputElement?.focus();
  }

  getTranslatedRegionName(region: RegionList, currentCLSLanguage: string) {
    const tranlsatedList = region['translated_regions'];
    if (tranlsatedList) {
      const tranlsatedRegion = tranlsatedList.filter((item) => {
        return item.languageCode.toLowerCase() === currentCLSLanguage;
      });
      if (tranlsatedRegion && tranlsatedRegion.length > 0) {
        return tranlsatedRegion[0].region_name;
      }
    }
    return region.region_name;
  }
}
